import  {Component} from 'react';
import axios from "axios";
import {apiConfigs,headers } from '../Config';



class Api extends Component {
    constructor(props) {
        super(props);
        axios.defaults.baseURL = apiConfigs.baseURL;
        axios.defaults.timeout = 120000;
    }

    // Login Page
    signUp = (mobile) =>{
       return  axios.post( 'v1/sign-up', {mobile}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    // Verify OTP Page
    signIn = (mobile , otp) =>{
       return  axios.post( 'v1/sign-in', {mobile , otp}, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    //  Register Page
    updateProfile = (request) =>{
       return  axios.put( 'v1/users/profiles/update', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }


    getUserInfo = (params = null) => {
        return axios.get( `v1/users/profiles/info`, {
            params,
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getContent = (slug) => {
        return axios.get( `v1/contents/${slug}`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getVehicles = () => {

        return axios.get( `v1/vehicles/vehicles`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }
    getSubscription = () => {
        return axios.get( `v1/payments/get-subscriptions`, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    updateVehicles = (request , id) => {
        return axios.put( `v1/vehicles/vehicles/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    deleteVehicles = (id) => {
        return axios.delete( `v1/vehicles/vehicles/${id}`,  {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    getTracks = (request , id) =>{
        return  axios.post( `v1/vehicles/get-tracks/${id}`, request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

    socketSendData = (request) => {
        return axios.get( `webservice2/socket/?type=get&mobile=${request.mobile}`, {
            headers
        })

    }


    // Payment
    getBankURL = (request) =>{
        return  axios.post( 'v1/payments/subscription-bank-url', request, {
            headers
        })
            .then(response => {
                return response.data;
            })
            .catch((error) => {
                throw error;
            });
    }

}
const API = new Api();
export default API;